import {
  advancedFormControl,
  advancedFormArray,
  FormControlTypeEnum,
} from '@magieno/common';
import {IsBoolean, IsInt, IsNotEmpty, IsString, ValidateNested} from '@pristine-ts/class-validator';
import {v4 as uuid} from 'uuid';
import {IncomeTaxPersonalChildCampOptions} from './income-tax-personal-child-camp.options';
import {FieldTypeEnum} from '../../../../../enums/field-type.enum';
import {translationBaseKey} from '../../../../../decorators/translation-base-key.decorator';

import {ErrorMessageBuilder} from '../../../../../builders/error-message.builder';
import {array, type} from '@pristine-ts/data-mapping-common';
import {CalculationDate} from '../../../../../models/calculation.date';

@translationBaseKey('income-tax-child-common-options')
export class IncomeTaxPersonalChildCommonOptions {
  @advancedFormControl({
    displayableElements: {},
    fieldType: FieldTypeEnum.String,
    type: FormControlTypeEnum.Input,
  })
  @IsString({buildErrorMessage: ErrorMessageBuilder.build})
  @IsNotEmpty({buildErrorMessage: ErrorMessageBuilder.build})
  id: string = uuid();

  // todo I think we said we should assign a value to the results
  @advancedFormControl({
    displayableElements: {
      labelTitle: {
        fr: 'Prénom',
        en: 'First name',
      },
      tooltip: {
        fr: '',
        en: '',
      },
    },
    fieldType: FieldTypeEnum.String,
    type: FormControlTypeEnum.Input,
  })
  @IsString({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsNotEmpty({ buildErrorMessage: ErrorMessageBuilder.build })
  firstName: string;

  // todo I think we said we should assign a value to the results
  @advancedFormControl({
    displayableElements: {
      labelTitle: {
        fr: 'Nom de famille',
        en: 'Last name',
      },
      tooltip: {
        fr: '',
        en: '',
      },
    },
    fieldType: FieldTypeEnum.String,
    type: FormControlTypeEnum.Input,
  })
  @IsString({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsNotEmpty({ buildErrorMessage: ErrorMessageBuilder.build })
  lastName: string;

  @array(IncomeTaxPersonalChildCampOptions)
  @advancedFormArray({
    emptyNumberOfChildrenFormToCreate: 0,
    elementClassType: IncomeTaxPersonalChildCampOptions,
  })
  @ValidateNested()
  camps: IncomeTaxPersonalChildCampOptions[] = [];

  @advancedFormControl({
    displayableElements: {
      labelTitle: {
        fr: 'Date de naissance de votre enfant',
        en: 'Child Birthdate',
      },
      tooltip: {
        fr: 'Indiquez la date de naissance de votre enfant. La date de naissance est utilisée pour déterminer l\'admissibilité à certains crédits d\'impôt.',
        en: 'Specify your child\'s birthdate. The birthdate is used to determine eligibility for certain tax credits.',
      },
    },
    fieldType: FieldTypeEnum.CalculationDate,
    type: FormControlTypeEnum.Input,
  })
  @IsNotEmpty({buildErrorMessage: ErrorMessageBuilder.build})
  @ValidateNested()
  @type(() => new CalculationDate())
  birthdate: CalculationDate;

  @advancedFormControl({
    displayableElements: {
      labelTitle: {
        fr: 'Est-ce que votre enfant est handicapé?',
        en: 'Is your child disabled?',
      },
      tooltip: {
        fr: 'Indiquez si votre enfant est handicapé. Le statut d\'invalidité de l\'enfant peut avoir des conséquences fiscales spécifiques.',
        en: 'Specify if your child is disabled. The child\'s disability status may have specific tax implications.',
      },
    },
    fieldType: FieldTypeEnum.Boolean,
    type: FormControlTypeEnum.BooleanSelect,
  })
  @IsNotEmpty({buildErrorMessage: ErrorMessageBuilder.build})
  @IsBoolean({buildErrorMessage: ErrorMessageBuilder.build})
  isDisabled: boolean;

  @advancedFormControl({
    displayableElements: {
      labelTitle: {
        fr: 'Revenu net de votre enfant?',
        en: 'Child\'s net income?',
      },
      tooltip: {
        fr: 'Indiquez le revenu net de votre enfant. Le revenu net peut être utilisé pour déterminer l\'admissibilité à certains crédits d\'impôt.',
        en: 'Specify your child\'s net income. The net income may be used to determine eligibility for certain tax credits.',
      },
    },
    fieldType: FieldTypeEnum.Money,
    type: FormControlTypeEnum.Input,
  })
  @IsNotEmpty({buildErrorMessage: ErrorMessageBuilder.build})
  @IsInt({buildErrorMessage: ErrorMessageBuilder.build})
  netIncome: number;
}
